import t from '~/scopes/campaign/data/metals/platinum.translations'
import SECTIONS from '~/scopes/campaign/data/metals/sections.translations'

export default {
  name: t.name,
  smartphone: {
    label: t.smartphoneLabel,
  },
  whatItDoes: {
    text: t.whatItDoesText,
    sourceRefs: ['ademe2024'],
  },
  extraction: [
    {
      text: t.extractionText1,
      sourceRefs: ['ademe2024', 'bgrPgm2022', 'scrreenPgm2023'],
    },
  ],
  quickFact: {
    text: t.quickFactText,
    sourceRefs: ['ademe2024', 'bgrPgm2022', 'scrreenPgm2023'],
  },
  impacts: {
    environmental: {
      summary: {
        text: t.envSummaryText,
        sourceRefs: ['ademe2024', 'bgrPgm2022'],
      },
      blocks: [
        {
          title: SECTIONS.environmentalWater,
          text: t.envWaterText,
          sourceRefs: ['bgrPgm2022', 'scrreenPgm2023'],
        },
        {
          title: SECTIONS.environmentalSoil,
          text: t.envSoilText,
          sourceRefs: ['bgrPgm2022', 'scrreenPgm2023'],
        },
        {
          title: SECTIONS.environmentalBiodiversity,
          text: t.envBiodiversityText,
          sourceRefs: ['bgrPgm2022', 'scrreenPgm2023'],
        },
        {
          title: SECTIONS.environmentalClimate,
          text: t.envClimateText,
          sourceRefs: ['ademe2024', 'bgrPgm2022'],
        },
      ],
    },
    human: {
      summary: {
        text: t.humanSummaryText,
        sourceRefs: ['bgrPgm2022'],
      },
      blocks: [
        {
          title: SECTIONS.humanHealth,
          text: t.humanHealthText,
          sourceRefs: ['bgrPgm2022'],
        },
        {
          title: SECTIONS.humanLegal,
          text: t.humanLegalText,
          sourceRefs: ['bgrPgm2022'],
        },
      ],
    },
    geopolitical: {
      summary: {
        text: t.geoSummaryText,
        sourceRefs: ['usgsMcs2025', 'ademe2024', 'bgrPgm2022'],
      },
      blocks: [
        {
          title: SECTIONS.geopoliticalDug,
          text: t.geoDugText,
          sourceRefs: ['usgsMcs2025', 'bgrPgm2022', 'scrreenPgm2023'],
        },
        {
          title: SECTIONS.geopoliticalProcessed,
          text: t.geoProcessedText,
          sourceRefs: ['ademe2024'],
        },
        {
          title: SECTIONS.geopoliticalLeverage,
          text: t.geoLeverageText,
          sourceRefs: ['ademe2024', 'bgrPgm2022'],
        },
      ],
    },
  },
  supplyRisk: {
    summary: {
      text: t.supplySummaryText,
      sourceRefs: ['ademe2024', 'ieaGcmo2025', 'bgrPgm2022', 'scrreenPgm2023'],
    },
    blocks: [
      {
        title: SECTIONS.supplyRiskReserves,
        text: t.supplyReservesText,
        sourceRefs: ['ademe2024', 'scrreenPgm2023'],
      },
      {
        title: SECTIONS.supplyRiskDemand,
        text: t.supplyDemandText,
        sourceRefs: ['ademe2024', 'ieaGcmo2025', 'bgrPgm2022'],
      },
    ],
  },
  recycling: {
    summary: {
      text: t.recyclingSummaryText,
      sourceRefs: ['ademe2024', 'ieaGcmo2025', 'jrcCircular2017'],
    },
    blocks: [
      {
        title: SECTIONS.recyclingInput,
        text: t.recyclingInputText,
        sourceRefs: ['ademe2024', 'ieaGcmo2025', 'jrcCircular2017'],
      },
      {
        title: SECTIONS.recyclingOutlook,
        text: t.recyclingOutlookText,
        sourceRefs: ['ademe2024', 'ieaGcmo2025', 'jrcCircular2017'],
      },
    ],
  },
} as const
